import {Icon} from '@ezcater/tapas';
import {faBuilding, faLocationDot, faUser} from '@fortawesome/pro-regular-svg-icons';
import parse from 'autosuggest-highlight/parse';
import {twMerge} from 'tailwind-merge';

import {type AddressSearchAutocompleteOptionProps} from '../types';

// ezx578::ARC::PreciseAddressNudge — EventBarV2 Where-styled option (see WhereAddressOption).
const AddressSearchAutocompleteExperimentOption: React.FC<AddressSearchAutocompleteOptionProps> = ({
  isSavedAddress = false,
  option,
  ...props
}) => {
  const icon = isSavedAddress ? (option.corporate ? faBuilding : faUser) : faLocationDot;
  const matches = option.structured_formatting.main_text_matched_substrings ?? [];
  const parts = parse(
    option.structured_formatting.main_text,
    matches.map(match => [match.offset, match.offset + match.length]),
  );

  return (
    <div {...props} className={twMerge('flex w-full min-w-0 items-center gap-3', props.className)}>
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-peppercorn-50 text-peppercorn-600">
        <Icon aria-hidden icon={icon} size="small" />
      </span>
      <span className="min-w-0 overflow-hidden text-left">
        <span className="block truncate text-sm text-peppercorn-800">
          {isSavedAddress ? (
            <span className="font-semibold">{option.structured_formatting.main_text}</span>
          ) : (
            parts.map((part, index) => (
              <span className={part.highlight ? 'font-bold' : 'font-normal'} key={index}>
                {part.text}
              </span>
            ))
          )}
        </span>
        <span className="block truncate text-sm text-peppercorn-500">
          {option.structured_formatting.secondary_text}
        </span>
      </span>
    </div>
  );
};

export default AddressSearchAutocompleteExperimentOption;
